<template>
  <div
    class="tw-rounded-2xl tw-bg-white dark:tw-bg-slate-800 tw-border tw-border-slate-100 dark:tw-border-slate-700 tw-shadow tw-py-3.5 tw-flex tw-flex-col tw-gap-3"
  >
    <div
      class="tw-text-sm tw-text-slate-700 dark:tw-text-slate-50 tw-font-geist tw-font-medium tw-px-4"
    >
      <div
        class="tw-flex tw-flex-col sm:tw-flex-row tw-justify-between tw-items-center tw-gap-3"
      >
        <div
          class="tw-text-sm tw-text-slate-700 dark:tw-text-slate-50 tw-font-geist tw-font-medium"
        >
          Stats
        </div>
        <div class="tw-flex tw-items-center tw-gap-2">
          <Button
            icon="pi pi-sync tw-text-slate-700 dark:tw-text-slate-50 tw-text-sm"
            class="tw-h-7 tw-shadow tw-w-8 tw-bg-white dark:tw-bg-slate-800 tw-border-transparent dark:tw-border-slate-700 tw-text-sm tw-font-medium tw-font-geist"
            @click="refreshData()"
          />
          <download-csv :data="formattedData">
            <Button
              label="CSV"
              icon="pi pi-download tw-mr-1.5 tw-text-sm"
              class="tw-h-7 tw-shadow tw-w-[68px] tw-px-2 tw-bg-white dark:tw-bg-slate-800 tw-border-transparent dark:tw-border-slate-700 tw-text-slate-700 dark:tw-text-slate-50 tw-text-sm tw-font-medium tw-font-geist"
            ></Button>
          </download-csv>
        </div>
      </div>
    </div>
    <div>
      <DataTable
        :value="formattedData"
        :paginator="true"
        :rows="10"
        responsiveLayout="scroll"
        :loading="props.loading"
        class="tw-bg-none tw-bg-transparent podcaster-stats-table"
        table-class="tw-bg-none tw-bg-transparent"
        :row-class="() => 'tw-bg-none tw-bg-transparent'"
      >
        <Column field="date" header="Date" />
        <Column field="downloads" header="Downloads" />
        <Column field="impressions" header="Impressions" />
        <Column field="imp_download_ratio" header="Imp/Download Ratio" />
        <Column field="revenue" header="Gross Profit" />
        <Column field="rev_download_ratio" header="Rev/Download Ratio" />
        <Column field="profit_margin" header="Profit Margin" />
        <Column field="ecpm" header="ECPM" />
      </DataTable>
    </div>
  </div>
</template>

<script setup>
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import Button from "primevue/button";
import { computed } from "vue";

const props = defineProps(["loading", "data"]);

const emit = defineEmits(["refreshData"]);

const formatStatsData = () => {
  let statsData = [];
  statsData = props.data.map((item) => {
    item.revenue = `$${
      item.revenue ? parseFloat(item.revenue).toFixed(2) : "0"
    }`;
    item.ecpm = `${item.ecpm ? parseFloat(item.ecpm).toFixed(4) : "0"}`;
    item.profit_margin = `${
      item.profit_margin ? (item.profit_margin * 100).toFixed(2) : "0"
    }%`;
    item.imp_download_ratio = `${
      item.imp_download_ratio
        ? parseFloat(item.imp_download_ratio).toFixed(3)
        : "0"
    }`;
    item.rev_download_ratio = `${
      item.rev_download_ratio
        ? parseFloat(item.rev_download_ratio).toFixed(3)
        : "0"
    }`;

    return item;
  });
  return statsData;
};

const formattedData = computed(() => formatStatsData(props.data));

const refreshData = () => {
  // Implement refresh functionality here
  emit("refreshData");
};
</script>

<style>
.podcaster-stats-table .p-paginator-bottom {
  border-color: transparent !important;
}
.podcaster-stats-table .p-datatable-thead th {
  background-color: transparent !important;
}
.podcaster-stats-table .p-paginator {
  background-color: transparent !important;
  border-color: transparent !important;
}
.podcaster-stats-table td,
.podcaster-stats-table th {
  border-color: #f1f5f9 !important; /* tw-border-slate-100 */
}
.tw-dark .podcaster-stats-table td,
.tw-dark .podcaster-stats-table th {
  border-color: #334155 !important; /* dark:tw-border-slate-700 */
}
</style>
